import { render, staticRenderFns } from "./PostPage.vue?vue&type=template&id=50676ce5&scoped=true"
import script from "./PostPage.vue?vue&type=script&lang=ts"
export * from "./PostPage.vue?vue&type=script&lang=ts"
import style0 from "./PostPage.vue?vue&type=style&index=0&id=50676ce5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50676ce5",
  null
  
)

export default component.exports